export default {
  toggleQrCodeModal: 'toggle-qr-code-modal'
}